(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const copy = JSON.parse(root.querySelector('[data-rf-copy]').textContent);
    const options = [...root.querySelectorAll('.rf-options input')];
    const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD',minimumFractionDigits:cents % 100 ? 2 : 0}).format(cents / 100);
    const form = root.querySelector('[data-rf-form]');
    const button = root.querySelector('[data-add-to-cart]');
    const error = root.querySelector('[data-cart-error]');
    const selected = () => root.querySelector('.rf-options input:checked');
    function render() {
      const input = selected();
      if (!input) { button.disabled = true; return; }
      const quantity = Number(input.dataset.units), total = Number(input.dataset.total), saving = Number(input.dataset.save);
      options.forEach(option => option.closest('.rf-option').classList.toggle('is-selected', option.checked));
      root.querySelector('[data-selected-total]').textContent = money(total);
      root.querySelector('[data-included-extras]').value = [copy.checklist, ...(quantity >= 5 ? [copy.pouch, copy.whistle] : [])].join(', ');
      error.hidden = true;
      let unlocked = 0;
      root.querySelectorAll('[data-gift]').forEach(gift => {
        const threshold = Number(gift.dataset.threshold), eligible = quantity >= threshold;
        if (eligible) unlocked++;
        gift.classList.toggle('is-locked', !eligible);
        gift.querySelector('[data-gift-tag]').textContent = eligible ? copy.free : copy.locked;
        gift.querySelector('[data-gift-status]').textContent = eligible ? copy.unlocked : `${copy.unlock_at} ${threshold} ${copy.units}`;
      });
      root.querySelector('[data-gift-count]').textContent = `${unlocked}/4`;
      const progress = quantity * 20;
      root.querySelector('[data-progress]').style.width = `${progress}%`;
      root.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', progress);
      root.querySelector('[role="progressbar"]').setAttribute('aria-valuetext', `${unlocked} of 4 extras unlocked`);
      root.querySelector('[data-shipping-message]').textContent = quantity === 1 ? copy.add_shipping : quantity === 3 ? copy.next_whistle : copy.free_unlocked;
      root.querySelector('[data-saving-note]').textContent = saving ? copy.saving_note.replace('{amount}',money(saving)).replace('{percent}', `${(100 * saving / (quantity * Number(root.dataset.unitBase))).toFixed(1)}%`) : copy.single_note;
    }
    options.forEach(option => option.addEventListener('change',render));
    let submitting = false;
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (submitting || !selected() || selected().disabled) return;
      submitting = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      root.querySelector('[data-button-label]').textContent = copy.adding;
      error.hidden = true;
      const payload = new FormData(form);
      payload.delete('return_to');
      options.forEach(option => { option.disabled = true; });
      try {
        const response = await fetch(form.action + '.js', {method:'POST',body:payload,headers:{Accept:'application/json'}});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || copy.add_error);
        window.location.assign(form.dataset.cartUrl);
      } catch (failure) {
        error.textContent = failure.message || copy.add_error;
        error.hidden = false;
        submitting = false;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        root.querySelector('[data-button-label]').textContent = copy.add_to_cart;
        options.forEach(option => { option.disabled = option.dataset.available !== 'true'; });
      }
    });
    root.querySelectorAll('[data-gallery-thumb]').forEach(button=>button.addEventListener('click',()=>{
      root.querySelectorAll('[data-gallery-thumb]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
      root.querySelectorAll('[data-gallery-panel]').forEach(panel=>panel.hidden=panel.dataset.galleryPanel!==button.dataset.galleryThumb);
    }));
    render();
  }
  function mount(scope=document) {scope.querySelectorAll('[data-rf-power]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount());else mount();
  document.addEventListener('shopify:section:load',event=>mount(event.target));
})();
